import * as Sentry from '@sentry/vue'

// ===== SSR =====

export function reportSsrRenderDuration(durationMs: number, route: string) {
  Sentry.metrics.distribution('ssr.render.duration', durationMs, {
    unit: 'millisecond',
    attributes: { route }
  })
}

export function reportSsrError(route: string, errorType: string) {
  Sentry.metrics.count('ssr.error', 1, { attributes: { route, errorType } })
}

export function reportSsrFallback(route: string) {
  Sentry.metrics.count('ssr.fallback', 1, { attributes: { route } })
}

export function reportSsrStatusCode(code: number, route: string) {
  Sentry.metrics.count('ssr.status_code', 1, { attributes: { code: String(code), route } })
}

// ===== API =====

export function reportApiDuration(apiName: string, durationMs: number, attrs?: Record<string, string>) {
  Sentry.metrics.distribution(`api.${apiName}.duration`, durationMs, {
    unit: 'millisecond',
    attributes: attrs
  })
}

export function reportApiError(apiName: string, errorType: string, attrs?: Record<string, string>) {
  Sentry.metrics.count(`api.${apiName}.error`, 1, { attributes: { errorType, ...attrs } })
}

// ===== Client =====

export function reportClientApiDuration(action: string, durationMs: number, attrs?: Record<string, string>) {
  Sentry.metrics.distribution(`client.api.${action}.duration`, durationMs, {
    unit: 'millisecond',
    attributes: attrs
  })
}

export function reportClientApiError(action: string, errorType: string, attrs?: Record<string, string>) {
  Sentry.metrics.count(`client.api.${action}.error`, 1, { attributes: { errorType, ...attrs } })
}

// ===== Page =====

export function reportPageLoadDuration(pageName: string, durationMs: number, attrs?: Record<string, string>) {
  Sentry.metrics.distribution(`page.${pageName}.load.duration`, durationMs, {
    unit: 'millisecond',
    attributes: attrs
  })
}

export function report404(path: string) {
  Sentry.metrics.count('page.404', 1, { attributes: { path } })
}

// ===== User Behavior =====

export function reportUserSearch(hasQuery: boolean, queryLength: number) {
  Sentry.metrics.count('user.search', 1, { attributes: { hasQuery: String(hasQuery) } })
  Sentry.metrics.distribution('user.search.query_length', queryLength, { unit: 'none' })
}

export function reportUserArticleClick(articleId: string, source: 'title' | 'read_more') {
  Sentry.metrics.count('user.article_click', 1, { attributes: { articleId, source } })
}

export function reportUserThemeToggle(theme: string) {
  Sentry.metrics.count('user.theme_toggle', 1, { attributes: { theme } })
}

// ===== Business =====

export function reportBusinessSuccess(action: string) {
  Sentry.metrics.count(`business.${action}.success`, 1)
}

export function reportBusinessError(action: string) {
  Sentry.metrics.count(`business.${action}.error`, 1)
}
